<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('table_head_DepartmentName_BudgetYear') ||
                  '部门名称/预算年度 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              v-if="allow('A')"
              @click="
                openEditPage({
                  pageType: 'add',
                  params: {},
                })
              "
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="140px"
        size="small"
        label-position="right"
      >
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$l('from_label_Budget_status') || '预算状态'">
              <el-checkbox-group v-model="form.reportBudgetStatusList">
                <el-checkbox label="N">{{
                  $l('INDEX.order_status_N') || '新增'
                }}</el-checkbox>
                <el-checkbox label="Y">{{
                  $l('INDEX.order_status_Y') || '已审核'
                }}</el-checkbox>
                <el-checkbox label="D">{{
                  $l('INDEX.order_status_D') || '已删除'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('from_label_budget_year') || '预算年度'"
              prop="budgetYear"
            >
              <el-input v-model="form.budgetYear"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              size="small"
              :label="$l('from_label_department_name') || '部门名称'"
            >
              <dict-select
                clearable
                v-model="form.depCode"
                url="/sys/common/dict/depDict"
                :placeholder="
                  $l('from_label_ps_department_name') || '请选择所属部门'
                "
                filterable
                :selectedLabel.sync="form.depName"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('from_label_team_name') || '团队名称'"
              ref="teamForm"
            >
              <dict-select
                clearable
                v-model="form.teamCode"
                url="/sys/common/dict/depByParentCode"
                :placeholder="$l('from_label_ps_team_name') || '请选择所属团队'"
                :body="teamparams"
                filterable
                :disabled="!form.depCode"
                size="mini"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('INDEX.create_date') || '创建时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="createTimeStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="createTimeEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.form_label_modification_time') || '修改时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="modifyTimeStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="modifyTimeEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  reportBudgetStatusList: ['N', 'Y'],
}
export default {
  data() {
    return {
      orderTypeParams: { dictType: 'orderType' },
      advqueryDialogVisible: false,
      form: { ...initForm },
      //创建日期限制
      createTimeStartPicker: this.createTimeEnd(),
      createTimeEndPicker: this.createTimeStart(),

      //修改日期限制
      modifyTimeStartPicker: this.modifyTimeEnd(),
      modifyTimeEndPicker: this.modifyTimeStart(),
    }
  },
  computed: {
    teamparams() {
      return { parentCode: this.form.depCode || '' }
    },
  },

  activated() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    // 修改时间限制
    modifyTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyTimeEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.modifyTimeEnd).getTime() < time.getTime()
          }
        },
      }
    },
    modifyTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyTimeStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.modifyTimeStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 创建日期限制
    createTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.createTimeEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.createTimeEnd).getTime() < time.getTime()
          }
        },
      }
    },
    createTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.createTimeStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.createTimeStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    openEditPage({ pageType, params = {} }) {
      this.$router.push({
        name: 'financial-finSet-budget-detail',
        params: { ...params, pageType },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
